import React from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationBack from 'material-ui/svg-icons/navigation/arrow-back';
import FlatButton from 'material-ui/FlatButton';

const style = {
    toolbar : {
        color: '#FFF',
        width: '100%',
        display: 'flex',
        minHeight: '64px',
        paddingLeft: '24px',
        paddingRight: '24px',
        top: 0,
        position: 'fixed',
        zIndex: 1100,
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
        borderRadius: 0,
    },
};

const FormAppBar = (props, context) => (
    <AppBar
        className="toolbar"
        title={props.title}
        style={style.toolbar}
        iconElementLeft={
            <IconButton
                onMouseUp={context.onCancel}
                onTouchEnd={context.onCancel}
            >
            <NavigationBack />
            </IconButton>
        }
        iconElementRight={
            <FlatButton
                type="submit"
                disabled={!context.canSubmit}
                label={props.submitButtonLabel || 'Save'}
            />
        }
    />
);

FormAppBar.contextTypes = {
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    canSubmit: PropTypes.bool
};

export default FormAppBar;
